import {Component, Injector, OnInit, ViewChild} from '@angular/core';
import {AdminDocument} from "../../models/adminDocument";
import {AdminDocumentService} from "../../services/adminDocument/admin-document.service";
import Swal, {SweetAlertResult} from "sweetalert2";
import {TableComponent} from "../ui/table/table.component";
import {NgxSmartModalService} from "ngx-smart-modal";
import {CompanyDocument} from "../../models/CompanyDocument";
import {BaseComponent} from "../base/base.component";
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-admins-settings',
  templateUrl: './admins-settings.component.html',
  styleUrls: ['./admins-settings.component.scss']
})
export class AdminsSettingsComponent extends BaseComponent implements OnInit{

  @ViewChild('adminDocumentsTable') adminDocumentsTable: TableComponent | undefined;

  tabNumber: number = 0; //diverso da 0 per comodità sviluppo
  adminDocument: AdminDocument = new AdminDocument();
  modelDocument: File | undefined;
  modelDocumentUrl: string = '';

  constructor(public route: ActivatedRoute, public adminDocumentService: AdminDocumentService, public modal: NgxSmartModalService, public serviceInjector: Injector) {
    super(serviceInjector);
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(){
    this.adminDocumentsTable?.loadData('/adminDocuments', {requestedTo: 'company'}, (item: any) => new AdminDocument(item)  )
  }

  async setTabNumber(index: number) {
    this.tabNumber = index;
  }

  async uploadDocument(event: MouseEvent) {
    event.preventDefault();

    this.adminDocument['requestedTo'] = 'company';

    let response = await this.adminDocumentService.uploadAdminDocumentModel(this.adminDocument);

    if (response.success){
      // Clear form
      this.adminDocument = {
        name: '',
        description: '',
        isMandatory: '',
        hasExpirationDate: '',
        modelUrl: ''
      };
      
      const fileInput = document.getElementById('model-document') as HTMLInputElement;
      if (fileInput) {
        fileInput.value = '';
      }

      Swal.fire({
        icon: 'success',
        title: "Documento caricato con successo"
      })
      this.adminDocumentsTable?.reloadPage();
    } else {
      Swal.fire({
        icon: 'error',
        title: "Errore durante il caricamento del documento"
      })
    }
  }


  openEditDocumentModal(documentToEdit: AdminDocument) {
    this.modal.getModal('editDocumentModal').setData(documentToEdit);
    this.modal.getModal('editDocumentModal').open();
  }

  removeDocumentModel(documentToDelete: AdminDocument) {
    Swal.fire({
      icon: 'warning',
      title: "Sei sicuro di voler eliminare il documento selezionato?",
      showCancelButton: true,
      confirmButtonText: "Si, elimina il documento selezionato",
      cancelButtonText: "No, annulla l'operazione"
    })
        .then( async (response: SweetAlertResult) => {
          if (response.isConfirmed) {
            if ( (await this.adminDocumentService.deleteDocument(documentToDelete)).success ){
              Swal.fire({
                icon: 'success',
                title: 'Documento eliminato con successo'
              })
              this.adminDocumentsTable?.reloadPage();
            } else {
              Swal.fire({
                icon: 'error',
                title: "Errore nella cancellazione del documento, riprova"
              })
            }
          }
          if (response.isDismissed) {
            // niente
          }
        });
  }

  clearModalData(modalName: string) {
    this.modal.resetModalData(modalName)
  }

  async chooseDocumentModel(event: any) {
    this.modelDocument = event.target.files[0];
    
    if(!this.modelDocument) return;

    const formData = new FormData();
    formData.append('file', this.modelDocument)

    this.showSpinner()

    const response = await this.adminDocumentService.uploadModelDocument(formData);
    this.modelDocumentUrl = response.data
    this.adminDocument['modelUrl'] = this.modelDocumentUrl;

    if (response.success) {
      this.hideSpinner()
      Swal.fire({
          icon: 'success',
          title: 'Documento caricato con successo'
      })
      this.adminDocumentsTable?.reloadPage();
  } else {
      this.hideSpinner()
      Swal.fire({
          icon: 'error',
          title: 'Errore nel caricamento del documento'
      })
  }
  }

  async updateDocument(documentUpdated: AdminDocument) {
    documentUpdated.modelUrl = this.modelDocumentUrl;
    let response = await this.adminDocumentService.updateCompanyDocumentModel(documentUpdated);

    if ( response.success ) {
      Swal.fire({
        icon: 'success',
        title: "Documento aggiornato con successo"
      })
          .then( _ => this.adminDocumentsTable?.reloadPage());
      this.modal.getModal('editDocumentModal').close();
    } else {
      Swal.fire({
        icon: 'error',
        title: "Errore durante l'aggiornamento del documento"
      });
    }
  }
}
